<script>
import Swal from 'sweetalert2';

import {
  getCepInfo,
  getCities,
  getDistricts,
  getEvents,
  getParish,
} from '../api/formMethods';
import { fireGenericError, getInfoByOperationPK } from '../utils/helpers';
import { required } from 'vuelidate/lib/validators';
import {
  inputClean,
  cpfCnpjValid,
  dateAfterToday,
  cepValid,
} from '../utils/customValidations';

import LoadingState from '../components/LoadingState.vue';
import ResumeResidencial from '../components/Resume/ResumeResidencial.vue';

export default {
  components: {
    LoadingState,
    ResumeResidencial,
  },
  data() {
    return {
      stage: 1,
      objDTO: null,
      operationPK: null,
      coverages: [],
      events: [],
      districts: [],
      citiesSinistro: [],
      parishesSinistro: [],
      loading: {
        coverages: false,
        events: false,
        distritoSinistro: false,
        cidadeSinistro: false,
        bairroSinistro: false,
      },
    };
  },
  validations() {
    return {
      objDTO: {
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        ComunicanteContacto: {
          ParentescoId: {
            required,
          },
        },
        SeguradoContacto: {
          Nome: { required, inputClean },
          NrContribuinte: { required, cpfCnpjValid },
          DataNascimento: { required, dateAfterToday },
          nrID: { required, inputClean },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
          SinistroEventoId: { required },
          SinistroDescricao: { required, inputClean },
          SeguradoDanos: { required, inputClean },
          SinistroCodigoPostal: { required, cepValid },
          SinistroDistritoId: { required },
          SinistroConcelhoId: { required },
          SinistroFreguesiaId: { required },
          SinistroMoradaNrPorta: { required },
          SinistroLocalReferencia: { required },
          SinistroMorada: { required, inputClean },
        },
      },
    };
  },
  methods: {
    back(newStage) {
      this.stage = newStage;
    },
    async policySelected(operationPK) {
      if (operationPK) {
        window.scrollTo(0, 0);

        try {
          this.loading.coverages = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.events = events;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;
        } catch (error) {
          console.error(error);
          fireGenericError();
        } finally {
          this.loading.coverages = false;
        }
      }
    },
    async changeCoverage() {
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.loading.events = true;
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );
      this.loading.events = false;
    },
    async changeCepSinistro() {
      if (!this.$v.objDTO.Sinistro.SinistroCodigoPostal.$invalid) {
        this.loading.distritoSinistro = true;
        const res = await getCepInfo(this.objDTO.Sinistro.SinistroCodigoPostal);
        console.log(res);

        const anyEmpty = Object.values(res).some((x) => x === null || x === '');
        const { DistritoUonId, ConcelhoUonId, FreguesiaUonId, Morada } = res;
        this.loading.distritoSinistro = false;

        if (DistritoUonId) {
          this.objDTO.Sinistro.SinistroDistritoId = DistritoUonId;
          await this.changeStateOcorrencia();
        }
        if (ConcelhoUonId) {
          this.objDTO.Sinistro.SinistroConcelhoId = ConcelhoUonId;
          await this.changeCityOcorrencia();
        }

        if (FreguesiaUonId)
          this.objDTO.Sinistro.SinistroFreguesiaId = FreguesiaUonId;

        if (Morada) this.objDTO.Sinistro.SinistroMorada = Morada;

        if (anyEmpty) {
          Swal.fire({
            toast: true,
            icon: 'warning',
            position: 'top',
            title:
              'Algumas informações do cep não foram retornadas, preencha manualmente',
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });
        }
      }
    },
    async changeStateOcorrencia() {
      this.loading.cidadeSinistro = true;
      this.objDTO.Sinistro.SinistroConcelhoId = null;
      this.objDTO.Sinistro.SinistroFreguesiaId = null;
      this.parishesSinistro = [];
      this.citiesSinistro = [];
      this.citiesSinistro = await getCities(
        this.objDTO.Sinistro.SinistroDistritoId
      );
      this.loading.cidadeSinistro = false;
    },
    async changeCityOcorrencia() {
      this.loading.bairroSinistro = true;
      this.objDTO.Sinistro.SinistroFreguesiaId = null;
      this.parishesSinistro = [];
      this.parishesSinistro = await getParish(
        this.objDTO.Sinistro.SinistroConcelhoId
      );
      this.loading.bairroSinistro = false;
    },
  },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);

    this.districts = await getDistricts();
  },
};
</script>

<template>
  <div v-if="objDTO !== null">
    <div class="container">
      <div class="white-frame" v-if="stage === 1">
        <div class="title-text mb-3"><b>Dados do Sinistro</b></div>
        <div class="row g-3 pb-3">
          <div class="col-md-6">
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              disabled
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-12"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc"
              >Descrição Ocorrência</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>

          <div
            class="col-md-12"
            :class="{
              'field-required': $v.objDTO.Sinistro.SeguradoDanos.$invalid,
            }"
          >
            <label class="form-label question" for="sinistroDesc"
              >Descrição dos bens danificados</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SeguradoDanos"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>

          <loading-state v-if="loading.coverages" />
        </div>

        <div v-if="!loading.coverages" class="row g-3 pb-3">
          <div
            class="col-md-6"
            v-if="riskUnits.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="riskUnit">Unidade de Risco</label>
            <Dropdown
              id="riskUnit"
              placeholder="Selecione"
              v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
              :options="riskUnits"
              optionLabel="Description"
              optionValue="RiskUnitId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="insuranceObjects.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="insuranceObject"
              >Objeto Segurado</label
            >
            <Dropdown
              id="insuranceObject"
              placeholder="Selecione"
              v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
              :options="insuranceObjects"
              optionLabel="Description"
              optionValue="InsuranceObjectId"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid,
            }"
          >
            <label class="form-label" for="coverages">Cobertura</label>
            <Dropdown
              id="coverages"
              placeholder="Selecione"
              @change="changeCoverage"
              v-model="objDTO.Apolice.ApoliceCoberturaId"
              :options="coverages"
              optionLabel="Description"
              optionValue="GisCoverageId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="coverages.length > 1"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroEventoId.$invalid,
            }"
          >
            <label class="form-label" for="evento">Evento</label>
            <Dropdown
              id="evento"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroEventoId"
              :options="events"
              :loading="loading.events"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>
        </div>

        <div class="title-text mb-3">
          <b>Local Sinistrado</b>
        </div>
        <div class="row g-3 mb-3">
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroCodigoPostal.$invalid,
            }"
          >
            <!-- 68909-320 -->
            <label class="form-label" for="cep">CEP</label>
            <InputText
              v-model="objDTO.Sinistro.SinistroCodigoPostal"
              class="form-control"
              @input="changeCepSinistro"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDistritoId.$invalid,
            }"
          >
            <label class="form-label" for="estado">
              Estado
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="districts.length == 0"
              />
            </label>
            <Dropdown
              id="estado"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroDistritoId"
              :options="districts"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeStateOcorrencia"
              class="form-control p-0"
              :disabled="loading.distritoSinistro"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroConcelhoId.$invalid,
            }"
          >
            <label class="form-label" for="cidade">
              Cidade
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.cidadeSinistro"
              />
            </label>
            <Dropdown
              id="cidade"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroConcelhoId"
              :options="citiesSinistro"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              @change="changeCityOcorrencia"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroFreguesiaId.$invalid,
            }"
          >
            <label class="form-label" for="bairro">
              Bairro
              <i
                class="pi pi-spin pi-spinner p-ml-2"
                v-if="loading.bairroSinistro"
              />
            </label>
            <Dropdown
              id="bairro"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroFreguesiaId"
              :options="parishesSinistro"
              :filter="true"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroMorada.$invalid,
            }"
          >
            <label class="form-label" for="logradouro">Logradouro</label>
            <InputText
              id="logradouro"
              v-model="objDTO.Sinistro.SinistroMorada"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroMoradaNrPorta.$invalid,
            }"
          >
            <label class="form-label" for="moradaNr">Nr</label>
            <InputText
              id="moradaNr"
              v-model="objDTO.Sinistro.SinistroMoradaNrPorta"
              class="form-control"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.SinistroLocalReferencia.$invalid,
            }"
          >
            <label class="form-label" for="moradaComp">Complemento</label>
            <InputText
              id="moradaComp"
              v-model="objDTO.Sinistro.SinistroLocalReferencia"
              class="form-control"
            />
          </div>
        </div>

        <div
          class="col-12 Aligner aligner-right mt-4"
          v-if="!$v.objDTO.$invalid"
        >
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="stage = 2"
          >
            Finalizar
          </button>
        </div>
        <!-- <dados-coberturas-eventos
        :loading="loading.coverages"
        :validation="$v"
        :apolice="objDTO.Apolice"
        :sinistro="objDTO.Sinistro"
        :riskUnits="riskUnits"
        :insuranceObjects="insuranceObjects"
        :coverages="coverages"
        :events="events" /> -->
      </div>
    </div>

    <div v-if="stage === 2">
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Resumo das informações para acionamento de Seguro</b>
          </div>
          <div
            class="output-format d-xl-flex justify-content-xl-evenly py-xl-3"
          >
            <resume-residencial
              :objDTO="objDTO"
              :events="events"
              :coverages="coverages"
              :riskUnits="riskUnits"
              :insuranceObjects="insuranceObjects"
              :estados="districts"
              :cidadesSinistro="citiesSinistro"
              :bairrosSinistro="parishesSinistro"
              @back="back"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
